import * as React from "react"
import { ActionType } from "@tenforce/toolbox-button-push-react"
import { IButton } from "../../../common/contextmenu"
import Button from "./Button"

interface Props {
    buttons: Record<string, IButton>
    buttonsVisibility: Record<string, boolean>
    executeCallButton: (button: IButton) => void
}

export const Buttons = ({
    buttons,
    buttonsVisibility,
    executeCallButton,
}: Props): JSX.Element => (
    <>
        {!!buttons && (
            <>
                {Object.values(buttons).map((button, i) =>
                    button.id && buttonsVisibility[button.id] === false ? (
                        <React.Fragment key={i} />
                    ) : (
                        <Button
                            key={i}
                            button={button}
                            executeCallButton={executeCallButton}
                            actionType={ActionType.icon}
                        />
                    ),
                )}
            </>
        )}
    </>
)

export default Buttons
